<h1 mat-dialog-title>Select contact</h1>
<div class="flex flex-col justify-start items-stretch" mat-dialog-content>
  <div class="flex flex-col justify-start items-stretch">
    @if (selectedContact$ | async; as selectedContact) {
      <div class="flex flex-row justify-start items-center w-full">
        <mat-form-field class="w-full flex-shrink-1">
          <mat-label>Selected contact</mat-label>
          <input
            matInput
            [value]="
              selectedContact.first_name + ' ' + selectedContact.last_name
            "
            disabled
          />
        </mat-form-field>
        <button mat-icon-button (click)="clearSelectedContact()">
          <mat-icon>close_small</mat-icon>
        </button>
      </div>
    } @else {
      <p>
        Search for a contact you have entered previously, or click the button
        below to add a new contact.
      </p>
      <mat-form-field>
        <mat-label>Search for contact</mat-label>
        <input
          matInput
          [formControl]="searchControl"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="selectContact($event)"
          [displayWith]="mapItem"
        >
          @for (contact of searchResults$ | async; track $index) {
            <mat-option [value]="contact">
              {{ contact.full_name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <button mat-stroked-button color="primary" (click)="openAddDialog()">
        Create new contact
      </button>
    }
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="'CANCELLED'">Cancel</button>
  <button mat-button [mat-dialog-close]="selectedContact$ | async">Save</button>
</div>
